export const HOME_BLOG_PREVIEW_POSTS = [
  {
    id: 'shutterstock-keyword-strategy-mistakes',
    slug: 'shutterstock-keyword-strategy-mistakes',
    title: 'Shutterstock Keyword Strategy: Best Practices and Common Mistakes',
    category: 'Guide',
    date: '2026-02-14',
    readTime: '6 min read',
    excerpt: 'Learn how to stay inside Shutterstock keyword limits while keeping titles and tags commercially useful.',
    image: '/blog/shutterstock-keywords-card.webp',
    featuredImage: '/blog/shutterstock-keywords-hero.webp',
    imageAlt: 'Shutterstock keyword strategy diagram',
    featuredImageAlt: 'Digital interface showing Shutterstock metadata optimization rules',
    featuredPriority: 2
  },
  {
    id: 'adobe-stock-keyword-order-guide',
    slug: 'adobe-stock-keyword-order-guide',
    title: 'Adobe Stock Keywords: How to Order and What to Watch Out For',
    category: 'Guide',
    date: '2026-02-12',
    readTime: '5 min read',
    excerpt: 'See how Adobe Stock keyword order affects ranking and how to fix the top 10 before you export.',
    image: '/blog/adobe-stock-keywords-card.webp',
    featuredImage: '/blog/adobe-stock-keywords-hero.webp',
    imageAlt: 'Adobe Stock keyword ordering interface example',
    featuredImageAlt: 'StockTag tool showing keyword reordering features',
    featuredPriority: 3
  },
  {
    id: 'free-stock-photo-keyword-generator-guide',
    slug: 'free-stock-photo-keyword-generator-guide',
    title: 'Free Stock Photo Keyword Generator Guide: Build Better Tags That Rank',
    category: 'Metadata',
    date: '2026-02-07',
    readTime: '13 min read',
    excerpt: 'Use a free stock photo keyword generator without producing spammy tags, then turn rough output into buyer-intent metadata.',
    image: '/blog/keyword-generator-free-card.webp',
    featuredImage: '/blog/keyword-generator-free-hero.webp',
    imageAlt: 'Magnifying glass over photo thumbnails symbolizing keyword research and discoverability',
    featuredImageAlt: 'Top-down desk with laptop and keyword notes for a free stock photo keyword generator workflow',
    featuredPriority: 1
  },
  {
    id: 'stock-photo-keyword-generator-plus',
    slug: 'stock-photo-keyword-generator-plus',
    title: 'Free Stock Photo Keyword Generator vs Full Metadata Workflow',
    category: 'Metadata',
    date: '2026-02-07',
    readTime: '9 min read',
    excerpt: 'Compare a free keyword-only flow with the full metadata workflow that handles titles, descriptions, QA, and export.',
    image: '/blog/keyword-generator-plus-card.webp',
    featuredImage: '/blog/keyword-generator-plus-hero.webp',
    imageAlt: 'Rejected vs approved folders representing clean metadata outcomes',
    featuredImageAlt: 'Magnifying glass over stock photo thumbnails for keyword discovery',
    featuredPriority: 4
  },
  {
    id: 'metadata-advantage-2026',
    slug: 'metadata-advantage-2026',
    title: 'Stock Photo Metadata Guide 2026: Rank Higher on Shutterstock and Adobe Stock',
    category: 'Metadata',
    date: '2026-02-07',
    readTime: '16 min read',
    excerpt: 'A practical stock metadata playbook for cleaner titles, safer keywords, and stronger search visibility.',
    image: '/blog/metadata-advantage.webp',
    featuredImage: '/blog/metadata-advantage-feature.webp',
    imageAlt: 'Vector campaign module grid with labels and metadata tags',
    featuredImageAlt: 'Reality warp stock visual with clean composition and metadata overlays',
    featuredPriority: 5
  }
];

const HOME_BLOG_PREVIEW_LOCALIZED_FIELDS = Object.freeze([
  'title',
  'category',
  'readTime',
  'excerpt',
  'imageAlt',
  'featuredImageAlt'
]);

export const buildLocalizedHomeBlogPreviewPosts = (translationMap = {}) => (
  HOME_BLOG_PREVIEW_POSTS.map((post) => {
    const translation = translationMap?.[post.slug];
    if (!translation || typeof translation !== 'object') return post;

    const localizedPreview = HOME_BLOG_PREVIEW_LOCALIZED_FIELDS.reduce((output, field) => {
      if (typeof translation[field] === 'string' && translation[field].trim()) {
        output[field] = translation[field];
      }
      return output;
    }, {});

    return { ...post, ...localizedPreview };
  })
);

export default HOME_BLOG_PREVIEW_POSTS;
